import ServicePage from "../components/site/ServicePage";
import { getService } from "../data/site";

const TASKS = [
  "Kitchen deep clean",
  "Bathrooms",
  "Floors",
  "Baseboards",
  "Appliances",
  "Cabinets",
  "Windows",
  "Trash removal",
  "Final walkthrough with you",
];

export default function MoveOut() {
  return (
    <ServicePage
      service={getService("move-out-cleaning")}
      tagline="Leave it spotless for the next owners."
      intro="Hand over your keys with pride. We deep clean top to bottom and finish with a walkthrough so everything is exactly as it should be. Estimates are free and quoted by square footage, bedrooms, and condition."
      tasksTitle="What's included in a move-out clean"
      tasks={TASKS}
      quoteHeading="Request a Free Estimate"
    />
  );
}
